<template>
  <v-list dense class="pa-0" data-test="stop-card">
    <v-list-item
      :class="['mt-2', 'rounded-lg', 'border', 'elevation-2', stopClass]"
      :disabled="isDisabled"
      @click="() => emit('click')"
    >
      <v-list-item-icon class="stop-card-icon">
        <v-icon :color="iconColor">{{ props.icon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>
          <vs-text :class="isDisabled && 'stop-disabled'" data-test="stop-card-title">{{
            props.title
          }}</vs-text>
        </v-list-item-title>
        <v-list-item-subtitle v-for="(subtitle, i) in props.subtitles" :key="i">
          <vs-text
            :class="isDisabled && 'stop-disabled'"
            type="caption"
            :data-test="`stop-card-subtitle-${i}`"
            >{{ subtitle }}</vs-text
          >
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script setup lang="ts">
import VsText from '@/components/vision/VsText.vue'
import { computed } from 'vue'

type StopCardState = 'disabled' | 'incomplete' | 'completed' | 'errored'

const props = withDefaults(
  defineProps<{
    icon: string
    title: string
    subtitles?: string[]
    state: StopCardState
  }>(),
  {
    subtitles: () => [],
  },
)

const emit = defineEmits<{
  (e: 'click'): void
}>()

const isDisabled = computed(() => props.state === 'disabled')

const iconColor = computed(() => {
  switch (props.state) {
    case 'disabled':
      return 'var(--color-grey--lighter)'
    case 'incomplete':
      return 'blue'
    case 'completed':
      return 'green'
    case 'errored':
      return 'red'
    default:
      return ''
  }
})

const stopClass = computed(() => (isDisabled.value ? 'stop-disabled' : 'stop-card'))
</script>

<style scoped>
/* Remove default v-list-item hover styles comes with @click event */
.v-list-item::before {
  display: none !important;
}

.stop-card {
  gap: 16px;
  padding: 0 16px;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out;

  &::after {
    content: none;
  }

  > .stop-card-icon {
    margin: 8px 0;
    align-self: center;
  }
}

.stop-card:hover {
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

.vs-caption {
  line-height: 1;
}

.stop-disabled {
  color: var(--color-grey--lighter);
}
</style>
